// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Product Catalogue API
 * Endpoints for querying product catalogue data including products and their versions.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  GetAllVersionsResponse,
  GetLatestVersionResponse,
  GetProductsResponse,
  HealthResponse,
} from '../models/index';
import {
  GetAllVersionsResponseFromJSON,
  GetAllVersionsResponseToJSON,
  GetLatestVersionResponseFromJSON,
  GetLatestVersionResponseToJSON,
  GetProductsResponseFromJSON,
  GetProductsResponseToJSON,
  HealthResponseFromJSON,
  HealthResponseToJSON,
} from '../models/index';

export interface V1VersionsVersionProductsGetRequest {
  version: string;
  serviceCode?: string;
  tierCode?: string;
  cloudProviderName?: string;
  regionCode?: string;
  orbBillableMetricID?: string;
  resourceTypeCode?: string;
  incrementValue?: number;
}

/**
 *
 */
export class DefaultApi extends runtime.BaseAPI {
  /**
   * Returns the health status of the service.
   * Health check
   */
  async healthGetRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<HealthResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/health`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      HealthResponseFromJSON(jsonValue),
    );
  }

  /**
   * Returns the health status of the service.
   * Health check
   */
  async healthGet(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<HealthResponse> {
    const response = await this.healthGetRaw(initOverrides);
    return await response.value();
  }

  /**
   * Returns all available product catalogue versions.
   * List product versions
   */
  async v1VersionsGetRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetAllVersionsResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/versions`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      GetAllVersionsResponseFromJSON(jsonValue),
    );
  }

  /**
   * Returns all available product catalogue versions.
   * List product versions
   */
  async v1VersionsGet(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetAllVersionsResponse> {
    const response = await this.v1VersionsGetRaw(initOverrides);
    return await response.value();
  }

  /**
   * Returns the latest available product catalogue version.
   * Get latest product version
   */
  async v1VersionsLatestGetRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetLatestVersionResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/versions/latest`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      GetLatestVersionResponseFromJSON(jsonValue),
    );
  }

  /**
   * Returns the latest available product catalogue version.
   * Get latest product version
   */
  async v1VersionsLatestGet(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetLatestVersionResponse> {
    const response = await this.v1VersionsLatestGetRaw(initOverrides);
    return await response.value();
  }

  /**
   * Returns products from the catalogue filtered by the provided query parameters. The version parameter is required. All other parameters are optional filters.
   * List products
   */
  async v1VersionsVersionProductsGetRaw(
    requestParameters: V1VersionsVersionProductsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetProductsResponse>> {
    if (requestParameters['version'] == null) {
      throw new runtime.RequiredError(
        'version',
        'Required parameter "version" was null or undefined when calling v1VersionsVersionProductsGet().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['serviceCode'] != null) {
      queryParameters['serviceCode'] = requestParameters['serviceCode'];
    }

    if (requestParameters['tierCode'] != null) {
      queryParameters['tierCode'] = requestParameters['tierCode'];
    }

    if (requestParameters['cloudProviderName'] != null) {
      queryParameters['cloudProviderName'] =
        requestParameters['cloudProviderName'];
    }

    if (requestParameters['regionCode'] != null) {
      queryParameters['regionCode'] = requestParameters['regionCode'];
    }

    if (requestParameters['orbBillableMetricID'] != null) {
      queryParameters['orbBillableMetricID'] =
        requestParameters['orbBillableMetricID'];
    }

    if (requestParameters['resourceTypeCode'] != null) {
      queryParameters['resourceTypeCode'] =
        requestParameters['resourceTypeCode'];
    }

    if (requestParameters['incrementValue'] != null) {
      queryParameters['incrementValue'] = requestParameters['incrementValue'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/versions/{version}/products`;
    urlPath = urlPath.replace(
      `{${'version'}}`,
      encodeURIComponent(String(requestParameters['version'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      GetProductsResponseFromJSON(jsonValue),
    );
  }

  /**
   * Returns products from the catalogue filtered by the provided query parameters. The version parameter is required. All other parameters are optional filters.
   * List products
   */
  async v1VersionsVersionProductsGet(
    requestParameters: V1VersionsVersionProductsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetProductsResponse> {
    const response = await this.v1VersionsVersionProductsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
